import { render, staticRenderFns } from "./addNote.vue?vue&type=template&id=3e767ce2&"
import script from "./addNote.vue?vue&type=script&lang=ts&"
export * from "./addNote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports